export const agreementKeys = {
    all: ['agreements'] as const,
    detail: (id: string) => [...agreementKeys.all, 'detail', id] as const,
    access: (id: string) => [...agreementKeys.all, 'access', id] as const,
    history: (id: string) => [...agreementKeys.all, 'history', id] as const,
    historyPage: (id: string, page: number, perPage: number) => [...agreementKeys.history(id), 'page', page, perPage] as const,
    notes: (id: string) => [...agreementKeys.all, 'notes', id] as const,
    notesPage: (id: string, page: number, perPage: number) => [...agreementKeys.notes(id), 'page', page, perPage] as const,
    authorisedContacts: (id: string) => [...agreementKeys.all, 'authorised-contacts', id] as const,
    authorisedContactsPage: (id: string, page: number, perPage: number) =>
        [...agreementKeys.authorisedContacts(id), 'page', page, perPage] as const,
    byQuote: (quoteId: string) => [...agreementKeys.all, 'by-quote', quoteId] as const,
    soldItems: (id: string) => [...agreementKeys.all, 'sold-items', id] as const,
    invoices: (id: string) => [...agreementKeys.all, 'invoices', id] as const,
    cashPosition: (id: string) => [...agreementKeys.all, 'cash-position', id] as const,
    livePaymentLink: (id: string) => [...agreementKeys.all, 'live-payment-link', id] as const,
    leftToPay: (id: string) => [...agreementKeys.all, 'left-to-pay', id] as const,
    financials: (id: string) => [...agreementKeys.all, 'financials', id] as const,
    invoicingCandidates: (dealerId: string, productId: string | null) =>
        [...agreementKeys.all, 'invoicing-candidates', dealerId, productId ?? 'none'] as const,
};
